/*
 * @@Author: zhouwei
 * @Date: 2024-08-13 10:03:39
 * @Description:
 */
import React from 'react';
import Cookies from 'js-cookie';
import { Provider } from 'mobx-react';
import { createRoot } from 'react-dom/client';
import { LocaleProvider } from '@ok/blade';

import rootStore from '../common/stores';

import Routers from './routers';

import 'react-select-okjp/dist/react-select.css';
import '_common/less/index.less';
import '_common/fonts/iconfont-OKJ-Account.css';
// 旧的@ok/Dialog、@ok/Alert使用到的字体图标，升级后需要移除该css
import '_common/fonts/iconfont.css';

const lang = Cookies.get('locale').toLowerCase();

import(`../local/${lang}`)
  .then((data) => {
    const { default: localeData } = data;
    const root = createRoot(document.querySelector('#app'));
    root.render(
      <Provider {...rootStore}>
        <LocaleProvider
          localeData={localeData}
          normalCsr
          noRemoteData
          fetchConfig={{
            project: 'okj_account_main',
            site: 'common',
          }}
        >
          {Routers}
        </LocaleProvider>
      </Provider>
    );
  })
  .catch(() => {});
